/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { ProjectStyle } from '@jira/platform__project-types/src/project-types.tsx';
import { defaultProps } from '@jira/platform__default-props/src/defaultProps.tsx';
import {
	ContextualAnalyticsData as ContextualAnalyticsDataBase,
	type AnalyticsContextData,
} from '@atlassian/jira-product-analytics-bridge';
import { useProject as useProjectDI } from '../../controllers/project/index.tsx';
import { generateViewId } from '../../utils/generate-view-id.tsx';

export type ContextualAnalyticsDataProps = AnalyticsContextData & {
	menuId: string;
	stack?: string[];
};

export type IssuesContextualAnalyticsDataProps = AnalyticsContextData & {
	navigatorScope: string;
	useProject?: typeof useProjectDI;
};

export const ContextualAnalyticsData = ({
	attributes,
	menuId,
	stack = defaultProps.emptyArray,
	...rest
}: ContextualAnalyticsDataProps): React.JSX.Element => (
	<ContextualAnalyticsDataBase
		{...rest}
		attributes={{
			viewId: generateViewId(menuId, ...stack),
			navigationLayer: 'container',
			...attributes,
		}}
	/>
);

export const IssuesContextualAnalyticsData = ({
	attributes,
	navigatorScope,

	useProject = useProjectDI,
	...rest
}: IssuesContextualAnalyticsDataProps): React.JSX.Element => {
	const { data: project } = useProject();
	const projectConfig =
		(project?.isSimplified ? ProjectStyle.NEXT_GEN : ProjectStyle.CLASSIC) || undefined;
	const projectType = project?.type || undefined;
	return (
		<ContextualAnalyticsDataBase
			{...rest}
			attributes={{
				...attributes,
				projectConfig,
				projectType,
				navigatorScope,
			}}
		/>
	);
};
